import * as React from 'react';

type DoseSpotNotificationsState = {
  count: number;
};

export const DoseSpotNotificationsContext = React.createContext<DoseSpotNotificationsState>({
  count: 0,
});
